export class Month {
  public static readonly January  = '1';
  public static readonly February  = '2';
  public static readonly March  = '3';
  public static readonly April = '4';
  public static readonly May = '5';
  public static readonly June = '6';
  public static readonly July = '7';
  public static readonly August = '8';
  public static readonly September = '9';
  public static readonly October = '10';
  public static readonly November = '11';
  public static readonly December = '12';
}
